export const STANDARD_FREQUENCIES = ['Daily', 'Monthly', 'Weekly'];
